import EntityType from '@enums/EntityType';

export default function isOutsidLevel(entities, level) {
  const hideNestedEntities = level?.options?.hideNestedEntities;
  const above =
    entities?.entity.above || entities?.role?.above || entities?.group?.above;
  if (level.type === EntityType.ORGANISATION) {
    return;
  }
  if (level.type === EntityType.GROUP) {
    if (entities.group?.uuid === level.uuid) {
      return;
    }
    if (hideNestedEntities) {
      return true;
    }
    return !above?.[EntityType.GROUP]?.has(level.uuid);
  }
  if (level.type === EntityType.ROLE) {
    return entities?.role?.uuid !== level.uuid;
  }
  if (level.type === EntityType.MANAGER) {
    // Preserve the legacy no-op for design-level manager views; only the
    // Insights scope filter (which sets `scoped`) opts into subtree scoping.
    if (!level.scoped) {
      return;
    }
    const role = entities?.role;
    if (!role) {
      return true;
    }
    if (role.uuid === level.uuid) {
      return;
    }
    if (hideNestedEntities) {
      return true;
    }
    return !role.above?.[EntityType.MANAGER]?.has(level.uuid);
  }
  if (level.type === EntityType.ACTIVITY) {
    return entities?.activity?.uuid !== level.uuid;
  }
}
